import { useCallback, useEffect, useState } from 'react';
import { GetDashboardAPI, GetAppointmentsAPI } from '../../../api/API';
import { isToday, isInUpcomingRange, toYMD } from '../utils/dashboardDates';

// Status que são consultas reais (fora bloqueios, faltas, cancelamentos e reagendados)
const VALID_APPOINTMENT_STATUSES = ['scheduled', 'confirmed', 'confirmed_by_patient', 'waiting', 'doing', 'completed'];
const CONFIRMED_STATUSES = ['confirmed', 'confirmed_by_patient'];

/**
 * Dados do Início: o retorno do get_dashboard.php e a agenda completa de hoje
 * (o get_dashboard só traz os agendamentos ainda não confirmados).
 */
function useDashboardData(companyId) {
  const [dashboardData, setDashboardData] = useState(null);
  const [todayAppointments, setTodayAppointments] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (companyId == null) return;

    const today = toYMD(new Date());
    let dashboardResult = null;
    let appointmentsResult = null;
    let pending = 2;

    const finish = () => {
      pending -= 1;
      if (pending > 0) return;
      setDashboardData(dashboardResult);
      setTodayAppointments(
        (Array.isArray(appointmentsResult) ? appointmentsResult : [])
          .filter((a) => VALID_APPOINTMENT_STATUSES.includes(a.status))
          .sort((a, b) => new Date(a.date) - new Date(b.date))
      );
      setIsLoaded(true);
    };

    GetDashboardAPI(companyId, (result) => { dashboardResult = result; finish(); });
    GetAppointmentsAPI(companyId, today, today, (result) => { appointmentsResult = result; finish(); });
  }, [companyId]);

  // Etapa marcada no "Agora na clínica": corrige só aquele agendamento, sem recarregar o Início
  const updateStepChecks = useCallback((appointmentId, stepChecks) => {
    setTodayAppointments((list) => list.map((a) => (
      String(a.id) === String(appointmentId) ? { ...a, stepChecks } : a
    )));
  }, []);

  const groups = dashboardData?.AppointmentsToConfirm || [];
  const unconfirmed = (list) => (list || []).filter((a) => !CONFIRMED_STATUSES.includes(a.status));
  const todayUnconfirmed = groups.filter((g) => isToday(g.date)).flatMap((g) => unconfirmed(g.list));
  const upcomingUnconfirmed = groups
    .filter((g) => !isToday(g.date) && isInUpcomingRange(g.date))
    .flatMap((g) => unconfirmed(g.list));

  return {
    isLoaded,
    dashboardData,
    todayAppointments,
    updateStepChecks,
    toConfirm: [...todayUnconfirmed, ...upcomingUnconfirmed],
  };
}

export default useDashboardData;
